import React from 'react'
import FormCss from "./fom.module.scss";

function TextTitle(props) {
  return (
    <div>
        <p className={`${FormCss.tabclix__form_title}`}>{props.label}</p>
    </div>
  )
}

export default TextTitle